// extracted by mini-css-extract-plugin
export default {"main":"Items_main__qmu-y","heart":"Items_heart__VmfdE"};